import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {Q9HtmlDecoderPipe, SnackBarService} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  constructor(
    private translateSvc: TranslateService,
    private snackBar: SnackBarService,
    private clipboard: Clipboard,
    private decodeHtml: Q9HtmlDecoderPipe
  ) {}

  copyToClipboard(value: string, successMsg: string): void {
    const encodedValue = this.decodeHtml.transform(value);

    this.clipboard.copy(encodedValue);
    const message = this.translateSvc.instant(successMsg);

    this.snackBar.success(message);
  }
}
